<template >
    
    <iframe :id="id" :src="url" frameborder="0" width="100%" height="800px" scrolling="auto">
      <Authorization ref="blbl"  @ok="checkAuthorization"></Authorization>
    </iframe>

</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import PageLayout from '../page/PageLayout'
  import RouteView from './RouteView'
  import Authorization from '@/components/xdhm/Authorization'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: "IframePageContent",
    components: {
      Authorization
    },
    inject:['closeCurrent'],
    data () {
      return {
        url: "",
        id:"",
      }
    },
    created () {
      this.goUrl()
    },
    updated () {
      this.goUrl()
    },
    watch: {
      $route(to, from) {
        this.goUrl();
      }
    },
    methods: {
      goUrl () {
        let url = this.$route.meta.url
        let id = this.$route.path
        this.id = id
        //url = "http://www.baidu.com"
        console.log("------url------"+url)
        if (url !== null && url !== undefined) {
          //外部url加入token
          let tokenStr = "${token}";
          if(url.indexOf(tokenStr)!=-1){
            let token = Vue.ls.get(ACCESS_TOKEN);
            this.url = url.replace(tokenStr,token);
          }else{
            this.url = url;
          }
          if(url.indexOf('/jwbd/jcdx')>0){
            let that = this;
            httpAction('/sys/authorization/grant/verification',{'captchaType':'JDDX_AUTHORIZATION_USERNAME'},'post').then((res)=>{
              if(res.success){
                if(!res.result){
                  that.$refs.blbl.add({'idNumber':'','captchaType':'JDDX_AUTHORIZATION_USERNAME','toUrl':that.url});
                  that.$refs.blbl.title="授权";
                  that.$refs.blbl.disableSubmit = true;
                }else{
                  if(that.$route.meta.internalOrExternal != undefined && that.$route.meta.internalOrExternal==true){
                    that.closeCurrent();
                    window.open(that.url);
                  }
                }
              }else{
                that.$message.warning(res.message);
              }
            })
          }else{
            if(this.$route.meta.internalOrExternal != undefined && this.$route.meta.internalOrExternal==true){
              this.closeCurrent();
              window.open(this.url);
            }
          }
        }
      },
      checkAuthorization(e){
        if(e.ifJump!='1'){
         this.$message.warning("授权失败，请核实账号密码是否正确！"); 
         return;
        }else{
          this.closeCurrent();
          window.open(e.toUrl);
        }
      },
    }
  }
</script>

